<script setup>
import { ref, onMounted } from "vue";
import NavigationBar from "@/components/Layout/NavigationBar.vue";
import MainSection from "@/components/Layout/MainSection.vue";
import LiveTraining from "@/components/LiveTraining/LiveTrainingSummary.vue";
import VirtualTraining from "@/components/VirtualTraining/VirtualTrainingSummary.vue";
import Shop from "@/components/Shop/ShopSummary.vue";
import Footer from "@/components/Layout/Footer.vue";
</script>

<template>
  <div>
    <NavigationBar />
    <MainSection />
    <LiveTraining />
    <VirtualTraining />
    <Shop/>
    <Footer />
  </div>
</template>
